export default __webpack_public_path__ + "static/media/mp_merch_pres5.4ca6aab7.svg";